import React, { useEffect, useState, useContext } from "react";
import Navbar from "../components/Navbar";
import Chatbot from "../components/chat/Chatbot";
import RagFilesDropzone from "../components/ragfiles/RagFilesDropzone";
import RagFilesList from "../components/ragfiles/RagFilesList";
import { WorkspaceContext } from "../contexts/WorkspaceContext";
import {
  getRagFormats,
  uploadRagDocument,
  listRagDocuments,
  deleteRagDocument,
} from "../services/workspace-management";
import { FaRobot } from "react-icons/fa";

export default function RagFilesPage() {
  const { currentWorkspace } = useContext(WorkspaceContext);

  const [extensions, setExtensions] = useState([]);
  const [accept, setAccept] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const workspaceId = currentWorkspace?._id;

  useEffect(() => {
    getRagFormats()
      .then((data) => {
        if (data.status === 200) {
          setExtensions(data.extensions || []);
          setAccept(data.accept || "");
        }
      })
      .catch(() => {});
  }, []);

  const refresh = () => {
    if (!workspaceId) return;
    setLoading(true);
    listRagDocuments(workspaceId)
      .then((data) => {
        setFiles(data.documents || []);
      })
      .catch(() => setFiles([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId]);

  const handleUpload = async (file) => {
    if (!workspaceId || !file) return;
    setUploading(true);
    try {
      await uploadRagDocument(workspaceId, file);
      refresh();
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (documentId) => {
    if (!workspaceId || !documentId) return;
    try {
      await deleteRagDocument(workspaceId, documentId);
      refresh();
    } catch (err) {
      console.error("Erreur suppression document RAG:", err);
    }
  };

  return (
    <>
      <Navbar />
      <div className="tyn-content">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8">
              <div className="card border-0 mb-4">
                <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
                  <FaRobot size={22} className="text-primary" />
                  <h5 className="mb-0">Base de connaissances de Pélagie</h5>
                </div>
                <div className="card-body">
                  <p className="text-muted mb-0">
                    Gérez les documents que Pélagie pourra consulter pour
                    répondre aux questions posées dans cet espace.
                  </p>
                </div>
              </div>

              <RagFilesDropzone
                extensions={extensions}
                accept={accept}
                onUpload={handleUpload}
                disabled={uploading || !workspaceId}
              />
              <RagFilesList
                files={files}
                loading={loading}
                onDelete={handleDelete}
              />
            </div>
          </div>
        </div>
      </div>
      <Chatbot />
    </>
  );
}
